/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'RelationMailGroup'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('relationmailgroup'); // main translation loaded for relationmailgroup
		$translatePartialLoader.addPart('relation'); // one to many reference from main entity
		$translatePartialLoader.addPart('relationtype'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('relationsource'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('gender'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('clientof'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('langkey'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('mailgroup'); // one to many reference from main entity
		$translatePartialLoader.addPart('relation'); // coupling entity reference loaded for relation
		$translatePartialLoader.addPart('mailgroup'); // coupling entity reference loaded for mailgroup

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/relationmailgroup/relationmailgroup-dialog.html';

		return {
			/* new state for entity relationMailGroup */
			/* to access: ui-ref="relationmailgroup.list.new" */
			/* url: hostname/relationmailgroup/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				dataModel: null, // this data model is set from the new relation state OR from the save and new logic
				mappedByDisplayValue: null,
				dataModelType: null, // this data model type is the name of the modelobject, lowercase

				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				function($stateParams, $state, $uibModal, $rootScope) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'RelationMailGroupDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'RelationMailGroupFactory',
									'NewRelationMailGroupFactory',
									function(RelationMailGroupFactory, NewRelationMailGroupFactory) {
										// NOTE either this dialog was opened with the purpose of
										// - creating a new RelationMailGroup
										// - resuming the creation of a new new RelationMailGroup AFTER new instances were created of x..1 reference(s)

										// if dataModel is defined, we're coming back from a new created x..1 reference
										if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
											var model = $stateParams.dataModel;
											// reset 'remembered' values to prevent future misbehaviour
											$rootScope.previousStateParams.dataModel = null;
											$stateParams.dataModel = null;

											// instead of returning a new model, we return the updated model
											return model;
										} else {
											if (isEditMode) {
												// get the entity by its ID
												return RelationMailGroupFactory.get({ id: $stateParams.relationMailGroupId }).$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											} else {
												// get a new empty entity
												return NewRelationMailGroupFactory.get().$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											}
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function() {
							// process success result, if necessary
						})
						.catch(function(closeReason) {
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for relationMailGroup new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for relationMailGroup edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('relationmailgroup', {
		/* abstract state for entity relationMailGroup */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/relationmailgroup',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'RelationMailGroups',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('relationmailgroup.list', {
		/* list state for entity relationMailGroup */
		/* to access: ui-ref="relationmailgroup.list" */
		/* url: hostname/relationmailgroup/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/relationmailgroup/relationmailgroups.html',
				controller: 'RelationMailGroupController',
			},
		},
	});

	$stateProvider.state('relationmailgroup.detail', {
		/* detail state for entity relationMailGroup */
		/* to access: ui-sref="relationmailgroup.detail" */
		/* url: hostname/relationmailgroup/detail/:relationMailGroupId */
		url: '/detail/:relationMailGroupId',
		views: {
			'content@': {
				templateUrl: 'app/entities/relationmailgroup/relationmailgroup-detail.html',
				controller: 'RelationMailGroupDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'RelationMailGroupFactory',
				function($stateParams, RelationMailGroupFactory) {
					return RelationMailGroupFactory.get({ id: $stateParams.relationMailGroupId });
				},
			],
		},
	});

	/* url: http://<hostname>/relationmailgroup/list/new */
	$stateProvider.state('relationmailgroup.list.new', getNewState());
	/* url: http://<hostname>/relationmailgroup/list/:relationMailGroupId/edit */
	$stateProvider.state('relationmailgroup.list.edit', getEditState('/:relationMailGroupId/edit'));
	/* url: http://<hostname>/relationmailgroup/detail/:relationMailGroupId/edit */
	$stateProvider.state('relationmailgroup.detail.edit', getEditState('/edit'));
	// Relation.relationMailGroup with multiplicity 0..n points to RelationMailGroup
	/* url: http://<hostname>/relation/detail/:relationId/relationmailgroup/new */
	$stateProvider.state('relation.detail.newRelationMailGroup', getNewState('/relationmailgroup/new'));
	/* url: http://<hostname>/relation/detail/:relationId/relationmailgroup/:relationMailGroupId/edit */
	$stateProvider.state('relation.detail.editRelationMailGroup', getEditState('/relationmailgroup/:relationMailGroupId/edit'));
	// Rare case of mixing non-dto's on a dto screen
	/* url: http://<hostname>/user-relation/detail/:relationId/relationmailgroup/new */
	$stateProvider.state('user-relation.detail.newRelationMailGroup', getNewState('/relationmailgroup/new'));
	/* url: http://<hostname>/user-relation/detail/:relationId/relationmailgroup/:relationMailGroupId/edit */
	$stateProvider.state('user-relation.detail.editRelationMailGroup', getEditState('/relationmailgroup/:relationMailGroupId/edit'));
	// MailGroup.relationMailGroup with multiplicity 0..n points to RelationMailGroup
	/* url: http://<hostname>/mailgroup/detail/:mailGroupId/relationmailgroup/new */
	$stateProvider.state('mailgroup.detail.newRelationMailGroup', getNewState('/relationmailgroup/new'));
	/* url: http://<hostname>/mailgroup/detail/:mailGroupId/relationmailgroup/:relationMailGroupId/edit */
	$stateProvider.state('mailgroup.detail.editRelationMailGroup', getEditState('/relationmailgroup/:relationMailGroupId/edit'));
});
